import { render, staticRenderFns } from "./deleteRecord.vue?vue&type=template&id=7538f803&scoped=true&"
import script from "./deleteRecord.vue?vue&type=script&lang=js&"
export * from "./deleteRecord.vue?vue&type=script&lang=js&"
import style0 from "./deleteRecord.vue?vue&type=style&index=0&id=7538f803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538f803",
  null
  
)

export default component.exports